export enum DataTransferType {
  Files = 'Files'
}
